import {Outlet} from "react-router-dom";

export default function JournalEntryDetailsTab() {
    //this class exists to let me switch between overview and 
    // editing the profile details from with-in the same "overview" tab
    return (<Outlet/>)
}

